export enum DTAClientErrors {
  GENERIC_INITIALIZE_FAIL = 'Failed to initialize',
  FAILED_TO_VERIFY_HOSTNAME = 'Failed to verify hostname',
  NOT_RUNNING = 'Trust Assistant is not running',
  NOT_INSTALLED = 'Trust Assistant is not installed'
}
